import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import moment from 'moment';

export const momentAdapterFactory = () => {
    return adapterFactory(moment);
};
